/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from '../client/http-client';
import {
  type CreatePresignedUrlRequestDto,
  type CreatePresignedUrlResponseDto,
  type CreateShortUrlRequestDto,
  type CreateShortUrlResponseDto,
  type ErrorResponseDto,
  type GetNotionDataRequestDto,
  type PaymentData,
} from '../dto/data-contracts';

export class Util<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 노션 데이터 가져와서 넘겨주기
   *
   * @tags Util
   * @name GetNotionData
   * @summary 노션 데이터 가져와서 넘겨주기
   * @request POST:/v1/util/notion
   */
  getNotionData = (data: GetNotionDataRequestDto, params: RequestParams = {}) =>
    this.http.request<PaymentData, ErrorResponseDto>({
      path: `/v1/util/notion`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 사전에 서명된 R2 URL 생성
   *
   * @tags Util
   * @name CreatePresignedUrl
   * @summary 사전에 서명된 R2 URL 생성
   * @request POST:/v1/util/r2/presign
   */
  createPresignedUrl = (
    data: CreatePresignedUrlRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CreatePresignedUrlResponseDto, ErrorResponseDto>({
      path: `/v1/util/r2/presign`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 오픈 소스 YOURLS을 이용한 서버에서(https://c3v.me) api 통신을 통해 short URL 생성
   *
   * @tags Util
   * @name CreateShortUrlUsingYourls
   * @summary YOURLS short URL 생성
   * @request POST:/v1/util/shorturl
   */
  createShortUrlUsingYourls = (
    data: CreateShortUrlRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CreateShortUrlResponseDto, ErrorResponseDto>({
      path: `/v1/util/shorturl`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
